import { render, staticRenderFns } from "./ContentInfo.vue?vue&type=template&id=160cb54c"
import script from "./ContentInfo.vue?vue&type=script&lang=js"
export * from "./ContentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports